<div id="regras-limite-despesa-viagem-form" class="page-layout carded fullwidth inner-scroll">
    <!-- TOP BACKGROUND -->
    <div class="top-bg color-green"></div>
    <!-- / TOP BACKGROUND -->
    <!-- CENTER -->
    <div class="center">
        <!-- HEADER -->
        <div
            class="header color-green"
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <!-- APP TITLE -->
            <div fxLayout="row" fxLayoutAlign="start center">
                <button
                    mat-icon-button
                    class="mr-0 mr-sm-16"
                    [routerLink]="'/a2w/supervisor/cadastros/relatorio-despesas/regras-limite-despesas-viagens'">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <div
                    fxLayout="column"
                    fxLayoutAlign="start start"
                    [@animate]="{
                        value: '*',
                        params: { delay: '100ms', x: '-25px' }
                    }">
                    <div class="h2" *ngIf="pageType === 'edit'">
                        {{ regraLimite.codigoRegra }}
                    </div>
                    <div class="h2" *ngIf="pageType === 'new'">
                        Novo
                    </div>
                </div>
            </div>
            <!-- / APP TITLE -->

            <button
                mat-raised-button
                class="save-product-button"
                [disabled]="regraLimiteForm.invalid || isLoadingRequest"
                *ngIf="pageType === 'new'"
                (click)="addRegraLimite()"
            >
                Adicionar
            </button>

            <button
                mat-raised-button
                class="save-product-button"
                [disabled]="regraLimiteForm.invalid || isLoadingRequest"
                *ngIf="pageType === 'edit'"
                (click)="updateRegraLimite()"
            >
                Atualizar
            </button>
        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <!-- CONTENT -->
            <div class="content">
                <form name="regraLimiteForm" [formGroup]="regraLimiteForm" class="product w-100-p"
                    fxLayout="column" fxFlex>
                    <mat-tab-group>
                        <mat-tab label="Dados Gerais">
                            <div class="tab-content p-24" fusePerfectScrollbar>

                                <div fxLayout="column" fxLayoutAlign="center" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">                                                                               
                                    <div fxLayout="row">
                                        <div fxLayout="column">
                                            <mat-label style="margin-top: 2px;">Ativo: </mat-label>
                                        </div>
                                        <div fxLayout="column">
                                            <mat-slide-toggle formControlName="isChecked" fxLayout="column"
                                            style="margin-right: 10px; margin-left: 10px;">
                                        </mat-slide-toggle>
                                        </div>
                                    </div>
                                </div>

                                <div fxLayout="column" style="margin-top: 15px;" fxLayoutAlign="center" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start center">
                                    
                                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100"
                                    fxFlex.gt-sm="60">
                                        <mat-label>Descrição</mat-label>
                                        <input matInput 
                                            name="codigoRegra" 
                                            formControlName="codigoRegra"
                                            required [maxLength]="50"/>                                        
                                        <mat-hint align="end">{{regraLimiteForm.get('codigoRegra')?.value?.length || 0}} / 50</mat-hint>
                                    </mat-form-field>

                                    
                                
                                    <div fxFlex="2"></div>

                                    <mat-form-field appearance="outline" floatLabel="always" fxFlex="100"
                                    fxFlex.gt-sm="38">
                                        <mat-label>Valor</mat-label>
                                        <input type="number" step="0.01" matInput name="valorRegra" formControlName="valorRegra" required />
                                    </mat-form-field>

                                </div>

                                <div class="content-toggles" fxLayout="column">

                                    <div fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="start">
                                        <div fxLayout="column" fxFlex="65">
                                        <mat-label>Considerar na política de despesas por dia:</mat-label>
                                        </div>
                                        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start">
                                        <span style="margin-left: 10px;">
                                            <mat-slide-toggle formControlName="limiteDiario" [disabled]="vinculos.length > 0 || isLoadingButton">
                                            </mat-slide-toggle>
                                        </span>
                                        </div>
                                    </div>
                                </div>
                               
                            </div>
                        </mat-tab>
                        <mat-tab label="Vínculos">
                            <div class="tab-content p-24" fusePerfectScrollbar>
                                <div fxLayout="row" fxLayoutAlign="end end">                                    

                                    <div class="pb-16" fxLayout="row" fxLayoutAlign="end end" fxFlex="15">
                                        <button mat-fab class="mt-24 mt-md-0 " color="accent" appearance="outline" floatLabel="always"
                                        (click)='addVinculo()' [disabled]="vinculos.length > 2 || isLoadingButton">
                                        <mat-icon>add</mat-icon>
                                        </button>
                                    </div>

                                </div>    
                                <!-- ALTERAR -->                           
                                <table class="simple mb-16" [@animateStagger]="{value:'50'}">
                                    <thead>
                                        <tr>
                                            <th>Tipo de Vínculo</th>
                                            <th>Vínculo</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let vinculo of vinculos; trackBy: identify" style="cursor: pointer;">
                                            <td (click)="editVinculo(vinculo)">{{ buscaNomeTipoVinculo(vinculo.tipoVinculo) }}</td>
                                            <td (click)="editVinculo(vinculo)">{{ retornaDescricaoVinculo(vinculo) }}</td>
                                            <td>
                                                <div fxFlex="row" fxLayoutAlign="end center">                                                     
                                                    <button mat-icon-button aria-label="Toggle star" (click)="deleteVinculo(vinculo)">
                                                            <mat-icon>delete</mat-icon>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </form>
            </div>
            <!-- / CONTENT -->
        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>
